import axios, { AxiosResponse } from 'axios';

// 外部区域数据结构
export interface ExternalArea {
  id: number;
  customer_id: number;
  name: string;
  res_url: string;
  n: string;
  p0: string;
  create_time: string;
  remark?: string;
}

// 保存全局的 cookie 容器
let globalCookie: string = '';

// 创建一个独立于全局状态的登录函数
export async function externalLoginWithUrl(
  username: string, 
  password: string, 
  _apiUrl: string // 保留参数但不再使用，统一使用同域名
): Promise<ExternalArea[]> {
  // 直接使用当前部署域名的同源请求
  const baseURL = window.location.origin + '/indoorService';
  console.log('使用同域名请求:', baseURL);
  
  const client = axios.create({
    baseURL: baseURL,
    timeout: 20000,
  });

  try {
    // 登录
    const loginResponse: AxiosResponse = await client.post('/sys/login', { username, password });
    console.log('登录响应:', loginResponse.data);
    
    if (loginResponse.data && loginResponse.data.code === 200) {
      // 从响应头提取 cookie（通过代理时会传递）
      const setCookie = loginResponse.headers['set-cookie'] as string | string[] | undefined;
      if (setCookie) {
        if (Array.isArray(setCookie)) {
          globalCookie = setCookie.map(c => c.split(';')[0]).join('; ');
        } else {
          globalCookie = setCookie.split(';')[0];
        }
        console.log('提取的 Cookie:', globalCookie);
      }
      
      // 获取区域列表（使用同一个 client 实例，自动携带 cookie）
      const areaResponse = await client.post('/get', {
        'Area[]': {
          Area: {
            "@order": "id-",
          },
          query: 2,
        },
        '@role': 'OWNER',
        "total@": "/Area[]/total",
      });
      console.log('区域列表响应:', areaResponse.data);
      
      if (areaResponse.data && areaResponse.data.code === 200) {
        return areaResponse.data['Area[]'] || [];
      } else if (areaResponse.data && areaResponse.data.code === 407) {
        console.error('未登录错误 - Cookie 可能未正确传递');
      }
    }
    return [];
  } catch (error: any) {
    console.error('外部登录失败:', error?.message);
    if (error.response) {
      console.error('响应状态:', error.response.status);
      console.error('响应数据:', error.response.data);
    }
    return [];
  }
}

// 保留原有的全局初始化方式（兼容其他场景）
let axiosIns: ReturnType<typeof axios.create> | null = null;
let currentBaseURL: string | null = null;

export function initApiClient(baseURL: string): void {
  const fullBaseURL = baseURL.endsWith('/indoorService')
    ? baseURL
    : baseURL + '/indoorService';
  currentBaseURL = fullBaseURL;
  axiosIns = axios.create({
    baseURL: fullBaseURL,
    timeout: 20000,
  });
}

export function getAxiosIns() {
  if (!axiosIns) {
    axiosIns = axios.create({
      baseURL: '/indoorService',
      timeout: 20000,
    });
  }
  return axiosIns;
}

export function getCurrentBaseURL(): string | null {
  return currentBaseURL;
}

// 登录函数 - 接收明文用户名密码
export function loginWithCredentials(username: string, password: string) {
  return getAxiosIns()({
    url: '/sys/login',
    method: 'post',
    data: { username, password }
  });
}

// 获取区域列表
export function getAreaListData(params: Record<string, unknown> = {}, page: Record<string, unknown> = {}) {
  return getAxiosIns().post('/get', {
    'Area[]': {
      Area: {
        ...params,
        "@order": "id-",
      },
      ...page,
      query: 2,
    },
    '@role': 'OWNER',
    "total@": "/Area[]/total",
  });
}
